import axios from "axios";
import { useEffect, useMemo, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

import backArrow from "../assets/arrowLeftWhite.svg";
import RemitaForPayment from "../assets/Home/remitaLogo.png";
import Alert from "../components/Alert";
import RegularModal from "../components/Modal/regular";
import constants from "../constants";
import { formatAmount, formatDate } from "../utils";
import { Mdas } from "./components/mdas";
import styles from "./style.module.css";

var sha512 = require("js-sha512");

const RemitaCheckout = () => {
	const history = useHistory();
	const { state: locationState, search } = useLocation();
	const query = useMemo(() => new URLSearchParams(search), [search]);

	const [amount, setAmount] = useState(query.get("amount") || "");
	const [name, setName] = useState(query.get("name") || "");
	const [phoneNumber, setPhoneNumber] = useState(
		query.get("phoneNumber") || ""
	);
	const [email, setEmail] = useState(query.get("email") || "");
	const [ESBN, setESBN] = useState(query.get("esbn") || "");
	const [fetchingESBNDetails, setFetchingESBNDetails] = useState(false);
	const [billNumber, setBillNumber] = useState(
		locationState?.billNumber || query.get("billNumber") || ""
	);
	const [noBillPaymentRef, setNoBillPaymentRef] = useState("");
	const [fetchingBill, setFetchingBill] = useState(false);
	const [billInfo, setBillInfo] = useState(null);
	const [isOneChequePayment, setIsOneChequePayment] = useState(false);
	const [isDetailedPayment, setIsDetailedPayment] = useState(false);
	const [detailedPaymentId, setDetailedPaymentId] = useState("");
	const [splitRations, setSplitRations] = useState([]);
	const [address, setAddress] = useState(query.get("address") || "");
	const [revenue, setRevenue] = useState(query.get("revcode") || "");
	const [revenues, setRevenues] = useState([]);
	const [mda, setMda] = useState(query.get("mdacode") || "");
	const [isCoreTax, setIsCoreTax] = useState(false);
	const [remark, setRemark] = useState("");
	const [paying, setPaying] = useState(false);
	const [consolidatedPaymentAlertOpen, setConsolidatedAlertOpen] =
		useState(false);
	const [payingWithBillNumber, setPayingWithBillNumber] = useState(
		query.get("method") === "2" ? false : true
	);
	const [alert, setAlert] = useState({
		showing: false,
		type: null,
		message: ""
	});

	let MDAPublicKey;

	const RevenueHead = async () => {
		const res = await axios
			.get(`/settings/mdalinkedrevenue/${mda}`)
			.then((res) => (res.data || {}).data);
		setRevenues(res);
	};

	useEffect(() => {
		RevenueHead();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [mda]);

	useEffect(() => {
		const getBillAmount = async () => {
			try {
				setBillInfo(null);
				setFetchingBill(true);
				setRevenue("");
				setAmount("");
				setPaying(false);
				setSplitRations([]);
				setIsDetailedPayment(false);
				let bill = (
					await axios.get(`/account/billv2/${billNumber}`, {
						headers: {
							secureddata: process.env.REACT_APP_SECURED_DATA
						}
					})
				).data.data;

				setBillInfo(bill);
				setName(bill?.billDetails?.Name_on_Bill);
				setESBN(bill?.billDetails?.ESBN_PID_on_Bill);
				setPhoneNumber(bill?.PhoneNo);
				setEmail(bill?.Email);
				setAddress(
					bill?.billDetails?.CentralisedBillDetails[0].Address
				);

				if (bill?.billDetails?.Split_Payment) {
					let splitBill = await axios.get(
						`/txn/ppsmbhook/${billNumber}`,
						{
							headers: {
								secureddata: process.env.REACT_APP_SECURED_DATA
							}
						}
					);

					setSplitRations(splitBill.data.data);
				}

				if (bill?.billDetails?.CentralisedBillDetails?.length === 1) {
					const mdaCode =
						bill?.billDetails?.CentralisedBillDetails[0].RevenueCode.split(
							"/"
						)[0];

					setMda(mdaCode);
					setRevenue(
						bill?.billDetails?.CentralisedBillDetails[0].RevenueCode
					);
				} else {
					if (bill?.billDetails?.Detail_Pymt_Flg) {
						setIsDetailedPayment(true);
					}

					if (!bill?.billDetails?.Consolidated_Bill_Flg) {
						const MDA =
							bill?.billDetails?.CentralisedBillDetails[0].RevenueCode.split(
								"/"
							)[0];
						setMda(MDA);

						const MDACode =
							bill?.billDetails?.CentralisedBillDetails[0].MDA;
						const MDADeets = await axios
							.get(`/settings/mdacompany/${MDACode}`)
							.then((res) => res.data.data);

						if (MDADeets.One_Chq_Paymt) {
							setIsOneChequePayment(true);
							let highestAmountObj = {
								amount: 0,
								id: null
							};

							for (
								let i = 0;
								i <
								bill?.billDetails?.CentralisedBillDetails
									.length;
								i++
							) {
								const element =
									bill?.billDetails?.CentralisedBillDetails[
										i
									];
								if (
									parseFloat(element?.Amount) >
									highestAmountObj.amount
								) {
									highestAmountObj.amount = parseFloat(
										element.Amount
									);
									highestAmountObj.id = i;
								}
							}

							setRevenue(
								bill?.billDetails?.CentralisedBillDetails[
									highestAmountObj.id
								].RevenueCode
							);
						}
					}
				}
			} catch (error) {
				if (error.response) {
					setAlert({
						...alert,
						showing: true,
						type: "error",
						message:
							error.response.data?.msg ||
							error.response.data?.message ||
							error.response.data?.errors?.[0]?.message ||
							error.response.data?.errors?.details[0]?.message
					});
				} else {
					setAlert({
						...alert,
						showing: true,
						type: "error",
						message: error.message
					});
				}
			} finally {
				setFetchingBill(false);
			}
		};
		if (billNumber?.length >= 17) getBillAmount();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [billNumber]);

	useEffect(() => {
		const script = document.createElement("script");
		script.src =
			// window.location.hostname === process.env.REACT_APP_COY_PROD_HOSTNAME
			// ?
			"https://login.remita.net/payment/v1/remita-pay-inline.bundle.js";
		// : "https://demo.remita.net/payment/v1/remita-pay-inline.bundle.js";
		script.async = true;
		document.body.appendChild(script);
		// Cleanup: remove the script when the component is unmounted

		return () => document.body.removeChild(script);
	}, []);

	let RRR;

	const generateRemitaRRR = async (amt, revCode) => {
		setPaying(true);
		let apiKey;
		let merchantId;
		let serviceTypeId;

		let modifiedRevCode = revenue
			? revenue.split("/").join("-")
			: revCode.split("/").join("-");

		// Get MDA APIKey, MerchantID and PublicKey
		try {
			let MDACode;
			if (revCode?.split("/")[0] === "LGA10000")
				MDACode = revCode?.split("/")[1];
			else MDACode = revCode?.split("/")[0] || mda;
			const deets = await axios.get(
				`/account/servicetypecred/${MDACode}`,
				{
					headers: { secureddata: process.env.REACT_APP_SECURED_DATA }
				}
			);

			apiKey = deets.data.data.apiKey;
			merchantId = deets.data.data.merchantId;
			MDAPublicKey = deets.data.data.publicKey;
		} catch (error) {
			setPaying(false);
			if (error.response) {
				setAlert({
					...alert,
					showing: true,
					type: "error",
					message: `MDA credentials error: ${
						error.response.data?.msg ||
						error.response.data?.errors?.[0]?.message ||
						error.response.data?.errors?.details[0]?.message
					}`
				});
			} else {
				setAlert({
					...alert,
					showing: true,
					type: "error",
					message: `MDA credentials error: ${error.message}`
				});
			}
			return;
		}

		try {
			// if not on production, use test service type ID. Else, try and get service type ID
			// if (
			// 	window.location.hostname !==
			// 	process.env.REACT_APP_COY_PROD_HOSTNAME
			// )
			// 	serviceTypeId = "4430731";
			// else {
			const getServiceTypeId = await axios.get(
				`account/servicetype/${modifiedRevCode}`,
				{
					headers: { secureddata: process.env.REACT_APP_SECURED_DATA }
				}
			);

			serviceTypeId = getServiceTypeId.data.data.revenue.servicetype;
			// }
		} catch (error) {
			if (error.response) {
				console.log(`---serviceTypeError`, error.response.data);
				setAlert({
					...alert,
					showing: true,
					type: "error",
					message: `Service type error: ${
						error.response.data?.msg ||
						error.response.data?.errors?.[0]?.message ||
						error.response.data?.errors?.details[0]?.message
					}`
				});
			} else {
				setAlert({
					...alert,
					showing: true,
					type: "error",
					message: `Service type error: ${error.message}`
				});
			}
			setPaying(false);

			return;
		}

		try {
			const d = new Date();
			const url =
				// window.location.hostname ===
				// process.env.REACT_APP_COY_PROD_HOSTNAME
				// ?
				"https://login.remita.net/remita/exapp/api/v1/send/api/echannelsvc/merchant/api/paymentinit";
			// : "https://demo.remita.net/remita/exapp/api/v1/send/api/echannelsvc/merchant/api/paymentinit";

			const payerName = name;
			const description = "Enugu Tax Payer Bill";
			const orderId = d.getTime();

			const apiHash = sha512(
				merchantId +
					serviceTypeId +
					orderId +
					Number(amt ? amt : amount || billInfo?.Balance) +
					apiKey
			);

			let requestData = {
				serviceTypeId: serviceTypeId,
				amount: Number(amt ? amt : amount || billInfo?.Balance),
				orderId,
				payerName,
				payerPhone: phoneNumber || "081111111111111",
				payerEmail: email || "eirssupport@norlics.com.ng",
				description,
				customFields: [
					{
						name: "payerName",
						value: name,
						type: "ALL"
					},
					{
						name: "itemRecId",
						value: detailedPaymentId
					},
					{
						name: "payerPhoneNumber",
						value: phoneNumber || "081111111111111",
						type: "ALL"
					},
					{
						name: "payerEmail",
						value: email || "eirssupport@norlics.com.ng",
						type: "ALL"
					},
					{
						name: "CustReference",
						value: ESBN,
						type: "ALL"
					},
					{
						name: "CustomerId",
						value: ESBN,
						type: "ALL"
					},
					{
						name: "BillNumber",
						value: billNumber || "",
						type: "ALL"
					},
					{
						name: "AgencyCode",
						value: (revenue || revCode).split("/")[0],
						type: "ALL"
					},
					{
						name: "RevenueCode",
						value: revenue || revCode,
						type: "ALL"
					},
					{
						name: "Bill_from_which_Module",
						value:
							billInfo?.billDetails?.Bill_from_which_Module || "",
						type: "ALL"
					},
					{
						name: "address",
						value: address,
						type: "ALL"
					},
					{
						name: "remark",
						value: remark,
						type: "ALL"
					}
				]
			};

			if (Boolean(splitRations?.length)) {
				requestData.lineItems = splitRations;
			}

			const config = {
				headers: {
					dataType: "json",
					"Content-Type": "application/json",
					Authorization: `remitaConsumerKey=${merchantId},remitaConsumerToken=${apiHash}`
				}
			};
			const req = await axios.post(url, requestData, config);

			if (req.data.statusMessage === "Service Type is not Valid")
				throw new Error(
					"Remita hasn't activated the service type for this MDA yet."
				);
			// eslint-disable-next-line no-new-func
			const f = new Function("jsonp", `${req.data}`);

			f(function (ref) {
				RRR = ref.RRR;
			});

			if (
				!billNumber ||
				billInfo?.billDetails?.CentralisedBillDetails?.length <= 1 ||
				detailedPaymentId
			)
				paymentCallback();
		} catch (error) {
			setPaying(false);
			console.error(error);
			if (error.response) {
				setAlert({
					...alert,
					showing: true,
					type: "error",
					message:
						error.response.data?.msg ||
						error.response.data?.errors?.[0] ||
						error.response.data?.errors?.[0]?.message ||
						error.response.data?.errors?.details[0]?.message ||
						error.response?.data?.message ||
						error.response?.data.statusMessage ||
						error.response?.data?.responseMsg
				});
			} else {
				setAlert({
					...alert,
					showing: true,
					type: "error",
					message: error.message
				});
			}
		}
	};

	async function paymentCallback(amt, revCode) {
		const requestData = {
			paymentgateway: "REMITA",
			paymentoption: "noEsbn",
			paygatetranid: RRR,
			billnumber: payingWithBillNumber ? billNumber : noBillPaymentRef,
			billername: billInfo?.billDetails?.Name_on_Bill,
			billerphoneno: phoneNumber || "081111111111111",
			billeremail: email || "eirssupport@norlics.com.ng",
			amount: amt ? amt : amount.trim() || billInfo?.Balance,
			mda: mda || revCode.split("/")[0],
			revenue: revenue || revCode,
			payload: [
				{
					firstName: name,
					lastName: "",
					narration: "Remita Payment",
					amount: Number(amount),
					transactionId: "",
					processRrr: true,
					customFieldData: [
						{
							name: "rrr",
							value: RRR
						},
						{
							name: "itemRecId",
							value: detailedPaymentId
						},
						{
							name: "payerName",
							value: name
						},
						{
							name: "payerPhoneNumber",
							value: phoneNumber || "081111111111111"
						},
						{
							name: "payerEmail",
							value: email || "eirssupport@norlics.com.ng"
						},
						{
							name: "CustReference",
							value: ESBN
						},
						{
							name: "CustomerId",
							value: ESBN
						},
						{
							name: "BillNumber",
							value: payingWithBillNumber
								? billNumber
								: noBillPaymentRef
						},
						{
							name: "AgencyCode",
							value: (revenue || revCode).split("/")[0]
						},
						{
							name: "RevenueCode",
							value: revenue || revCode
						},
						{
							name: "Bill_from_which_Module",
							value:
								billInfo?.billDetails?.Bill_from_which_Module ||
								"",
							type: "ALL"
						},
						{
							name: "address",
							value: address,
							type: "ALL"
						},
						{
							name: "remark",
							value: remark,
							type: "ALL"
						}
					]
				}
			]
		};

		try {
			await axios.post(`${constants.BASE_URL}/taxpaid`, requestData);

			if (
				!billNumber ||
				billInfo?.billDetails?.CentralisedBillDetails?.length <= 1 ||
				detailedPaymentId
			)
				initializeRemita();
		} catch (error) {
			setPaying(false);
			if (error.response) {
				setAlert({
					...alert,
					showing: true,
					type: "error",
					message:
						error.response.data?.msg ||
						error.response.data?.errors?.[0] ||
						error.response.data?.errors?.[0]?.message ||
						error.response.data?.errors?.details[0]?.message ||
						error.response?.data?.message ||
						error.response.data.data.message
				});
			} else {
				setAlert({
					...alert,
					showing: true,
					type: "error",
					message: error.message
				});
			}
		}
	}

	const startPayment = async () => {
		try {
			if (
				billInfo?.billDetails?.CentralisedBillDetails?.length > 1 &&
				!isOneChequePayment &&
				!detailedPaymentId &&
				!isDetailedPayment &&
				!amount
			) {
				billInfo?.billDetails?.CentralisedBillDetails.map(
					async (bill) => {
						await generateRemitaRRR(
							+bill.Amount + +bill.OutstandingAmount,
							bill.RevenueCode
						);
						paymentCallback(
							+bill.Amount + +bill.OutstandingAmount,
							bill.RevenueCode
						);
						initializeRemita(
							+bill.Amount + +bill.OutstandingAmount,
							bill.RevenueCode
						);
					}
				);
			} else if (
				billInfo?.billDetails?.CentralisedBillDetails?.length > 1 &&
				!isOneChequePayment &&
				!detailedPaymentId &&
				!isDetailedPayment &&
				amount
			) {
				billInfo.billDetails?.CentralisedBillDetails.map(
					async (bill) => {
						let amt =
							((+bill.Amount + +bill.OutstandingAmount) /
								billInfo.Balance) *
							amount;

						await generateRemitaRRR(amt, bill.RevenueCode);
						paymentCallback(amt, bill.RevenueCode);
						initializeRemita(amt, bill.RevenueCode);
					}
				);
			} else if (
				isDetailedPayment &&
				billInfo?.billDetails?.CentralisedBillDetails.filter(
					(bill) => bill.ItemPaidStatus !== "PAID"
				).length > 1 &&
				!detailedPaymentId &&
				!amount
			) {
				billInfo?.billDetails?.CentralisedBillDetails.filter(
					(bill) => bill.ItemPaidStatus !== "PAID"
				).map(async (bill) => {
					await generateRemitaRRR(
						+bill.ItemAmt2Pay,
						bill.RevenueCode
					);
					paymentCallback(+bill.ItemAmt2Pay, bill.RevenueCode);
					initializeRemita(+bill.ItemAmt2Pay, bill.RevenueCode);
				});
			} else if (
				isDetailedPayment &&
				billInfo?.billDetails?.CentralisedBillDetails.filter(
					(bill) => bill.ItemPaidStatus !== "PAID"
				).length > 1 &&
				!detailedPaymentId &&
				amount
			) {
				billInfo?.billDetails?.CentralisedBillDetails.filter(
					(bill) => bill.ItemPaidStatus !== "PAID"
				).map(async (bill) => {
					let amt = (+bill.ItemAmt2Pay / billInfo?.Balance) * amount;
					await generateRemitaRRR(amt, bill.RevenueCode);
					paymentCallback(amt, bill.RevenueCode);
					initializeRemita(amt, bill.RevenueCode);
				});
			} else await generateRemitaRRR();
		} catch (error) {
			if (error.response) {
				setAlert({
					...alert,
					showing: true,
					type: "error",
					message:
						error.response.data?.msg ||
						error.response.data?.errors?.[0] ||
						error.response.data?.errors?.[0]?.message ||
						error.response.data?.errors?.details[0]?.message ||
						error.response?.data?.message
				});
			} else {
				setAlert({
					...alert,
					showing: true,
					type: "error",
					message: error.message
				});
			}
		}
	};

	// const publicKey = process.env.REACT_APP_REMITA_PUBLIC_KEY;

	const initializeRemita = async (amt, revCode) => {
		try {
			const remitaPaymentEngine = window.RmPaymentEngine.init({
				key: MDAPublicKey,
				firstName: name,
				lastName: "",
				narration: "Remita Payment",
				amount: amt ? amt : amount.trim() || billInfo?.Balance,
				transactionId: "",
				processRrr: true,
				extendedData: {
					customFields: [
						{
							name: "rrr",
							value: RRR
						},
						{
							name: "itemRecId",
							value: detailedPaymentId
						},
						{
							name: "payerName",
							value: name
						},
						{
							name: "payerPhoneNumber",
							value: phoneNumber || "081111111111111"
						},
						{
							name: "payerEmail",
							value: email || "eirssupport@norlics.com.ng"
						},
						{
							name: "CustReference",
							value: ESBN
						},
						{
							name: "CustomerId",
							value: ESBN
						},
						{
							name: "BillNumber",
							value: billNumber || ""
						},
						{
							name: "AgencyCode",
							value: (revenue || revCode).split("/")[0]
						},
						{
							name: "RevenueCode",
							value: revenue || revCode
						},
						{
							name: "Bill_from_which_Module",
							value:
								billInfo?.billDetails.Bill_from_which_Module ||
								"",
							type: "ALL"
						},
						{
							name: "address",
							value: address,
							type: "ALL"
						},
						{
							name: "remark",
							value: remark,
							type: "ALL"
						}
					]
				},
				onSuccess: function () {
					setPaying(false);
					setBillNumber("");
					setNoBillPaymentRef("");
					setPhoneNumber("");
					setEmail("");
					setName("");
					setESBN("");
					setAddress("");
					setAmount("");
					setDetailedPaymentId("");
					setIsDetailedPayment(false);
					setBillInfo("");
					setRevenue("");
					setMda("");
					setAlert({
						...alert,
						showing: true,
						type: "success",
						message:
							`You have successfully paid ₦ ${
								amount.trim() || billInfo?.Balance
							}` +
							(billNumber
								? ` for bill ${billNumber}`
								: ` for payment with ref ${noBillPaymentRef}`)
					});
					// if this page was opened from any bill payment module outside of the homepage
					if (locationState?.billNumber) {
						if (
							billInfo?.billDetails?.CentralisedBillDetails
								?.length > 1 &&
							billInfo?.billDetails?.CentralisedBillDetails[
								billInfo?.billDetails?.CentralisedBillDetails
									?.length - 1
							].RevenueCode === revCode
						)
							locationState?.goBackTo
								? history.push(locationState?.goBackTo, {
										paymentSuccessful: true
									})
								: history.goBack();
						else if (
							billInfo?.billDetails?.CentralisedBillDetails
								?.length > 1 &&
							billInfo?.billDetails?.CentralisedBillDetails[
								billInfo?.billDetails?.CentralisedBillDetails
									?.length - 1
							].RevenueCode !== revCode
						)
							return;
						else
							locationState?.goBackTo
								? history.push(locationState?.goBackTo, {
										paymentSuccessful: true
									})
								: history.goBack();
					}
					// if this page was opened from another site other than ours
					if (query.get("redirectURL"))
						window.location.href = `${query.get(
							"redirectURL"
						)}?paymentStatus=successful&billNumber=${query.get(
							"billNumber"
						)}`;
				},
				onError: function (error) {
					setPaying(false);
					setIsDetailedPayment(false);
					setDetailedPaymentId("");
					if (error.response) {
						setAlert({
							...alert,
							showing: true,
							type: "error",
							message:
								error.response.data?.msg ||
								error.response.data?.errors?.[0] ||
								error.response.data?.errors?.[0]?.message ||
								error.response.data?.errors?.details[0]
									?.message ||
								error.response?.data?.message ||
								error.response?.data?.responseMsg
						});
					} else {
						setAlert({
							...alert,
							showing: true,
							type: "error",
							message: error.message
						});
					}

					// if this page was opened from another site other than ours
					if (query.get("redirectURL")) {
						setTimeout(() => {
							window.location.href = `${query.get(
								"redirectURL"
							)}?paymentStatus=failed&errorMessage=${
								error.message
							}&billNumber=${query.get("billNumber")}`;
						}, 4000);
					}
				},
				onClose: () => {
					setPaying(false);
					setDetailedPaymentId("");
				}
			});
			await remitaPaymentEngine.showPaymentWidget();
		} catch (error) {
			console.error(error);
		} finally {
			setDetailedPaymentId("");
		}
	};

	const getESBNDetails = async () => {
		setFetchingESBNDetails(true);

		try {
			const res = await axios
				.get(`/users/esbnpid?anssid=${ESBN}`)
				.then((res) => (res.data || {}).data);

			if (res.accounttype === "individual") {
				if (!res?.firstname) {
					setName("");
					setAlert({
						...alert,
						showing: true,
						type: "error",
						message: "No data for this ESBN"
					});
				} else
					setName(
						`${res.firstname} ${res.middlename} ${res.surname}`
					);
				setAddress(res.residentialaddress || "");
				setPhoneNumber(res?.phonenumber || "");
				setEmail(res?.email || "");
			} else if (res.accounttype === "corporate") {
				setName(res.name);
				setAddress(res.stateOfficeAddress);
				setPhoneNumber(res?.phoneNumber || "");
				setEmail(res?.email || "");
			} else {
				setName(res.PayerName);
				setAddress(res.PropertyAddr);
			}
		} catch (error) {
			if (error.response) {
				setAlert({
					...alert,
					showing: true,
					type: "error",
					message:
						error.response.data?.msg ||
						error.response.data?.errors?.[0] ||
						error.response.data?.errors?.[0]?.message ||
						error.response.data?.errors?.details[0]?.message ||
						error.response.message
				});
			} else if (error.request) {
				setAlert((alert) => ({
					...alert,
					showing: true,
					type: "error",
					message: error.message
				}));
			} else {
				setAlert({
					...alert,
					showing: true,
					type: "error",
					message: error.message
				});
			}
		} finally {
			setFetchingESBNDetails(false);
		}
	};

	async function checkCoreTaxes() {
		try {
			const res = await axios.get(
				`/txn/chkcoretax/${revenue.split("/").join("-")}`
			);

			if (res?.data?.revenueCode) setIsCoreTax(true);
			else setIsCoreTax(false);
		} catch (error) {
			if (error.response) {
				setAlert({
					...alert,
					showing: true,
					type: "error",
					message:
						error.response.data?.msg ||
						error.response.data?.errors?.[0]?.message ||
						error.response.data?.errors?.details[0]?.message
				});
			} else {
				setAlert({
					...alert,
					showing: true,
					type: "error",
					message: error.message
				});
			}
		}
	}

	useEffect(() => {
		if (!payingWithBillNumber) {
			setRevenue("");
			setESBN("");
			setName("");
			setAddress("");
			setAmount("");
			setRemark("");
			setIsDetailedPayment(false);
			setDetailedPaymentId("");
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [mda]);

	useEffect(() => {
		if (mda && !payingWithBillNumber) checkCoreTaxes();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [revenue]);

	useEffect(() => {
		if (ESBN?.length >= 10 && !payingWithBillNumber) getESBNDetails();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [ESBN]);

	useEffect(() => {
		if (detailedPaymentId) startPayment();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [detailedPaymentId]);

	useEffect(() => {
		const getPaymentRef = async () => {
			try {
				const paymentRef = await axios.get(`getids/05`);

				setNoBillPaymentRef(paymentRef.data.Id);
			} catch (error) {
				if (error.response) {
					setAlert({
						...alert,
						showing: true,
						type: "error",
						message: `Payment Ref error: ${
							error.response.data?.msg ||
							error.response.data?.errors?.[0] ||
							error.response.data?.errors?.[0]?.message ||
							error.response.data?.errors?.details[0]?.message ||
							error.response?.data?.message ||
							error.response.data.data.message
						}`
					});
				} else {
					setAlert({
						...alert,
						showing: true,
						type: "error",
						message: `Payment Ref error: ${error.message}`
					});
				}
			}
		};

		if (!payingWithBillNumber) {
			getPaymentRef();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [payingWithBillNumber]);

	useEffect(() => {
		const delay = setTimeout(
			() =>
				setAlert({
					showing: false,
					type: null,
					message: ""
				}),
			3000
		);

		return () => clearTimeout(delay);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [!!alert.showing]);

	return (
		<div className={styles.page}>
			{alert.showing && <Alert text={alert.message} type={alert.type} />}
			{consolidatedPaymentAlertOpen && (
				<RegularModal
					showing={consolidatedPaymentAlertOpen}
					toggle={setConsolidatedAlertOpen}
				>
					<p>
						You will go through the payment{" "}
						{
							billInfo?.billDetails?.CentralisedBillDetails.filter(
								(bill) => bill.ItemPaidStatus !== "PAID"
							).length
						}{" "}
						times. Click okay to continue.{" "}
					</p>
					<button
						type="button"
						className="primary__btn"
						style={{
							display: "block",
							margin: "40px auto 0",
							padding: "0 25px"
						}}
						onClick={() => {
							setConsolidatedAlertOpen(false);
							startPayment();
						}}
					>
						Okay
					</button>
				</RegularModal>
			)}
			<main className={styles.main}>
				<div className={styles.remita__header}>
					<button
						type="button"
						className={styles.go__back}
						onClick={() => history.goBack()}
					>
						<img src={backArrow} alt="go back arrow" />
					</button>
					<img src={RemitaForPayment} alt="remita logo" />
				</div>
				<div className={styles.radio__btns}>
					<div>
						<input
							id="payWithBillNo"
							type="radio"
							value={true}
							checked={payingWithBillNumber}
							onChange={(e) => {
								setPayingWithBillNumber(true);
								setName("");
								setPhoneNumber("");
								setEmail("");
								setESBN("");
								setAmount("");
								setBillNumber("");
								setBillInfo(null);
								setAddress("");
								setRevenue("");
								setMda("");
								setRemark("");
								setIsCoreTax(false);
								setSplitRations([]);
								setIsDetailedPayment(false);
								setDetailedPaymentId("");
								setNoBillPaymentRef("");
							}}
							disabled={
								query.get("method") === "2" ||
								query.get("billNumber")
							}
						/>
						<label htmlFor="payWithBillNo">
							Pay With Bill Number
						</label>
					</div>
					<div>
						<input
							id="payWithoutBillNo"
							type="radio"
							value={false}
							checked={!payingWithBillNumber}
							onChange={(e) => {
								setPayingWithBillNumber(false);
								setName("");
								setPhoneNumber("");
								setEmail("");
								setESBN("");
								setAmount("");
								setBillNumber("");
								setBillInfo(null);
								setAddress("");
								setRevenue("");
								setMda("");
								setRemark("");
								setIsCoreTax(false);
								setSplitRations([]);
								setIsDetailedPayment(false);
								setDetailedPaymentId("");
							}}
							disabled={
								query.get("method") === "2" ||
								query.get("billNumber")
							}
						/>
						<label htmlFor="payWithoutBillNo">
							Pay{" "}
							<b>
								<i>Without</i>
							</b>{" "}
							Bill Number
						</label>
					</div>
				</div>
				<form
					className={styles.wrapper}
					onSubmit={(e) => {
						e.preventDefault();
						if (
							billInfo?.billDetails?.CentralisedBillDetails
								?.length > 1 &&
							!isOneChequePayment &&
							!isDetailedPayment
						)
							setConsolidatedAlertOpen(true);
						else if (
							billInfo?.billDetails?.CentralisedBillDetails
								?.length > 1 &&
							!isOneChequePayment &&
							isDetailedPayment
						) {
							if (
								billInfo?.billDetails?.CentralisedBillDetails.filter(
									(bill) => bill.ItemPaidStatus !== "PAID"
								).length > 1
							)
								setConsolidatedAlertOpen(true);
							else startPayment();
						} else startPayment();
					}}
				>
					{!payingWithBillNumber && (
						<>
							<div className={styles.single__input}>
								<label
									className={styles.input__label}
									htmlFor="paymentRef"
								>
									Payment Reference{" "}
									<span
										style={{
											fontSize: "12.5px",
											color: "#7e7e7e"
										}}
									>
										(Please save in case of need to resolve
										issue on this payment){" "}
									</span>
									<span style={{ color: "red" }}>*</span>
								</label>
								<input
									type="text"
									id="paymentRef"
									placeholder="Enter payment reference"
									value={noBillPaymentRef}
									readOnly
									required
								/>
							</div>
							<div className={styles.payments__double__inputs}>
								<Mdas
									setValue={(val) => setMda(val)}
									value={mda}
								/>
								<div>
									<label
										className={styles.input__label}
										htmlFor="mda"
									>
										Revenue{" "}
										{!mda && (
											<span
												style={{
													fontSize: "12.5px",
													color: "#7e7e7e"
												}}
											>
												(Pick MDA first)
											</span>
										)}{" "}
										<span style={{ color: "red" }}>*</span>
									</label>
									<select
										id="mda"
										className={styles.input__medium}
										name="mda"
										onChange={(e) => {
											setRevenue(e.target.value);
											if (!payingWithBillNumber) {
												setESBN("");
												setName("");
												setPhoneNumber("");
												setEmail("");
												setAddress("");
												setAmount("");
												setRemark("");
											}
										}}
										value={revenue}
										disabled={
											(payingWithBillNumber &&
												(!billNumber ||
													!mda ||
													!billInfo)) ||
											(!payingWithBillNumber && !mda) ||
											query.get("method") === "2"
										}
										required
									>
										<option value="">
											{revenues
												? "--Select Revenue head--"
												: "Loading..."}
										</option>
										{revenues &&
											revenues.map((getRev) => (
												<option
													key={getRev.Code}
													value={getRev.Code}
												>
													{getRev.Description}
												</option>
											))}
									</select>
								</div>
							</div>
						</>
					)}
					{payingWithBillNumber && (
						<div className={styles.single__input}>
							<label
								className={styles.input__label}
								htmlFor="BillNumber"
							>
								Bill Number{" "}
								<span style={{ color: "red" }}>*</span>
							</label>
							<input
								type="text"
								onChange={(e) => setBillNumber(e.target.value)}
								id="BillNumber"
								placeholder="Enter bill number"
								required
								value={billNumber}
								disabled={
									query.get("billNumber") ||
									locationState?.billNumber
								}
							/>
						</div>
					)}
					<div className={styles.payments__double__inputs}>
						<div>
							<label
								className={styles.input__label}
								htmlFor="ESBN"
							>
								ESBN/PID{" "}
								{(payingWithBillNumber || isCoreTax) && (
									<span style={{ color: "red" }}>*</span>
								)}{" "}
								{!payingWithBillNumber &&
									(!mda || !revenue) && (
										<span
											style={{
												fontSize: "12.5px",
												color: "#7e7e7e"
											}}
										>
											(Pick MDA & Revenue first)
										</span>
									)}
								{ESBN && ESBN.length < 10 && (
									<span
										style={{
											fontSize: "12.5px",
											color: "red"
										}}
									>
										(Must be, at least, 10 characters long)
									</span>
								)}
							</label>
							<input
								type="text"
								id="ESBN"
								placeholder="Enter your ESBN or PID"
								required={payingWithBillNumber}
								value={ESBN}
								onChange={(e) => {
									setESBN(e.target.value);
									if (!payingWithBillNumber) {
										setName("");
										setAddress("");
										setPhoneNumber("");
										setEmail("");
									}
								}}
								disabled={
									payingWithBillNumber ||
									query.get("method") === "2" ||
									(!payingWithBillNumber &&
										(!mda || !revenue))
								}
							/>
							{fetchingESBNDetails && (
								<p
									style={{
										fontSize: "12px",
										lineHeight: "0",
										margin: "10px 0 0",
										color: "#9e9e9e"
									}}
								>
									fetching details...
								</p>
							)}
						</div>
						<div>
							<label
								className={styles.input__label}
								htmlFor="name"
							>
								Name <span style={{ color: "red" }}>*</span>{" "}
								{isCoreTax && !ESBN && (
									<span
										style={{
											fontSize: "12.5px",
											color: "#7e7e7e"
										}}
									>
										(Enter ESBN/PID first)
									</span>
								)}
							</label>
							<input
								type="text"
								value={name}
								onChange={(e) => setName(e.target.value)}
								id="name"
								placeholder="Enter Name"
								required
								disabled={
									payingWithBillNumber ||
									query.get("method") === "2" ||
									(!payingWithBillNumber &&
										(!mda || !revenue)) ||
									isCoreTax
								}
							/>
						</div>
					</div>
					<div className={styles.payments__double__inputs}>
						<div>
							<label
								className={styles.input__label}
								htmlFor="phoneNumber"
							>
								Phone Number
							</label>
							<input
								type="tel"
								id="phoneNumber"
								placeholder="Enter phone number"
								value={phoneNumber}
								pattern="(?:0\d{10}|\+[1-9]\d{1,14})"
								title="Please enter a valid phone number."
								minLength={11}
								onChange={(e) => setPhoneNumber(e.target.value)}
							/>
						</div>
						<div>
							<label
								className={styles.input__label}
								htmlFor="email"
							>
								Email
							</label>
							<input
								type="email"
								id="email"
								placeholder="Enter email"
								value={email}
								onChange={(e) => setEmail(e.target.value)}
							/>
						</div>
					</div>
					<div className={styles.single__input}>
						<label
							className={styles.input__label}
							htmlFor="address"
						>
							Address <span style={{ color: "red" }}>*</span>{" "}
							{isCoreTax && !ESBN && (
								<span
									style={{
										fontSize: "12.5px",
										color: "#7e7e7e"
									}}
								>
									(Enter ESBN/PID first)
								</span>
							)}
						</label>
						<input
							id="address"
							placeholder="Enter address"
							value={address}
							onChange={(e) => setAddress(e.target.value)}
							disabled={
								payingWithBillNumber ||
								query.get("method") === "2" ||
								(!payingWithBillNumber && (!mda || !revenue)) ||
								isCoreTax
							}
							required
						/>
					</div>
					{/* Revenue Head Bill Breakdown */}
					{fetchingBill && (
						<p style={{ textAlign: "center" }}>Loading...</p>
					)}
					{billInfo && (
						<table className={styles.table}>
							<thead>
								<tr>
									<th>S/N</th>
									<th>CATEGORY (REVENUE HEAD)</th>
									<th>Outstanding Bill (₦)</th>
									{isDetailedPayment && <th>Discount (₦)</th>}
									<th>Current Bill (₦)</th>
									{isDetailedPayment && (
										<th style={{ visibility: "hidden" }}>
											Pay
										</th>
									)}
								</tr>
							</thead>
							<tbody>
								{billInfo?.billDetails?.CentralisedBillDetails.map(
									(each, i) => (
										<tr key={each.MDA}>
											<td>{i + 1}.</td>
											<td>{each.BillDescription}</td>
											<td>
												₦
												{formatAmount(
													each.OutstandingAmount
												)}
											</td>
											{isDetailedPayment && (
												<td>
													₦
													{formatAmount(
														each.ItemDiscount
													)}
												</td>
											)}
											<td>
												₦{formatAmount(each.Amount)}
											</td>
											{isDetailedPayment &&
												(each.ItemPaidStatus ===
												"PAID" ? (
													<td>
														<span
															className={
																styles.paid__item
															}
														>
															PAID
														</span>
													</td>
												) : (
													<td>
														<button
															type="button"
															className={
																styles.detail__pay_btn
															}
															onClick={() => {
																setDetailedPaymentId(
																	each?.id
																);
																setAmount(
																	`${each?.ItemAmt2Pay}`
																);
																setRevenue(
																	each?.RevenueCode
																);
																setMda(
																	each?.RevenueCode.split(
																		"/"
																	)[0]
																);
															}}
															disabled={paying}
														>
															{paying &&
															detailedPaymentId ===
																each?.id
																? "Paying..."
																: "Pay"}
														</button>
													</td>
												))}
										</tr>
									)
								)}
								<tr className={styles.no__border_bottom}>
									<td></td>
									<td></td>
									<td className={styles.discount}>
										DISCOUNT
									</td>
									<td className={styles.discount}>
										₦
										{formatAmount(
											billInfo?.billDetails
												?.Total_Discount_Bill_Amount
										)}
									</td>
								</tr>
								<tr className={styles.no__border_bottom}>
									<td></td>
									<td></td>
									<td className={styles.discount}>
										Total Outstanding
									</td>
									<td className={styles.discount}>
										₦
										{formatAmount(billInfo?.totOutstanding)}
									</td>
								</tr>
								<tr className={styles.no__border_bottom}>
									<td></td>
									<td></td>
									<td className={styles.total}>TOTAL DUE</td>
									<td className={styles.total}>
										₦
										{formatAmount(
											billInfo?.billDetails
												?.Total_Grand_Bill_Amount
										)}
									</td>
								</tr>
							</tbody>
						</table>
					)}
					{Boolean(billInfo?.paymentDetails?.length) && (
						<>
							<h3 className={styles.payment__history_header}>
								Bill Payment History
							</h3>
							<table className={styles.table}>
								<thead>
									<tr>
										<th>S/N</th>
										<th style={{ visibility: "hidden" }}>
											Payment Date
										</th>
										<th>Payment Date</th>
										<th>Amount Paid</th>
									</tr>
								</thead>
								<tbody>
									{billInfo?.paymentDetails?.map(
										(each, i) => (
											<tr key={each.PaymentDate}>
												<td>{i + 1}.</td>
												<td></td>
												<td>
													{formatDate(
														each.PaymentDate
													)}
												</td>
												<td>
													₦{formatAmount(each.Amount)}
												</td>
											</tr>
										)
									)}
									<tr className={styles.no__border_bottom}>
										<td></td>
										<td></td>
										<td className={styles.discount}>
											Total Paid
										</td>
										<td className={styles.discount}>
											₦
											{formatAmount(billInfo?.totPayment)}
										</td>
									</tr>
									<tr className={styles.no__border_bottom}>
										<td></td>
										<td></td>
										<td className={styles.total}>
											Balance
										</td>
										<td className={styles.total}>
											₦{formatAmount(billInfo?.Balance)}
										</td>
									</tr>
								</tbody>
							</table>
						</>
					)}
					{billInfo?.billDetails?.CentralisedBillDetails?.length ===
						1 && (
						<div className={styles.payments__double__inputs}>
							<Mdas setValue={(val) => setMda(val)} value={mda} />
							<div>
								<label
									className={styles.input__label}
									htmlFor="revenue"
								>
									Revenue{" "}
									<span style={{ color: "red" }}>*</span>
								</label>
								<select
									id="revenue"
									className={styles.input__medium}
									name="revenue"
									onChange={(e) => {
										setRevenue(e.target.value);
									}}
									value={revenue}
									disabled={
										(payingWithBillNumber &&
											(!billNumber ||
												!mda ||
												!billInfo)) ||
										(!payingWithBillNumber && !mda) ||
										query.get("method") === "2" ||
										query.get("billNumber")
									}
									required
								>
									<option value="">
										{revenues
											? "--Select Revenue head--"
											: "Loading..."}
									</option>
									{revenues &&
										revenues.map((getRev) => (
											<option
												key={getRev.Code}
												value={getRev.Code}
											>
												{getRev.Description}
											</option>
										))}
								</select>
							</div>
						</div>
					)}
					<div className={styles.single__input}>
						<label className={styles.input__label} htmlFor="remark">
							Remark
						</label>
						<textarea
							id="remark"
							placeholder="Enter remark"
							value={remark}
							onChange={(e) => setRemark(e.target.value)}
							rows={3}
						/>
					</div>
					{locationState?.referrer !== "/coupon/purchase" &&
						query.get("method") !== "2" &&
						!query.get("billNumber") &&
						!billInfo?.billDetails?.Detail_Pymt_Flg && (
							<div className={styles.single__input}>
								<label
									className={styles.input__label}
									htmlFor="amount"
								>
									Amount to Pay (
									{billInfo?.billDetails
										?.CentralisedBillDetails?.length > 1 &&
										"Min. Amount: ₦ 2000."}{" "}
									Ignore and Click “Pay Now” to pay in full){" "}
									<span style={{ color: "red" }}>*</span>
								</label>
								<input
									type="number"
									value={amount}
									onChange={(e) => setAmount(e.target.value)}
									id="amount"
									placeholder="Enter amount"
									required={!payingWithBillNumber}
								/>
								{billInfo?.billDetails?.CentralisedBillDetails
									?.length > 1 &&
									amount &&
									amount < 2000 && (
										<span style={{ color: "red" }}>
											Amount must be, at least, ₦ 2000
										</span>
									)}
							</div>
						)}
					{!billInfo?.billDetails?.Detail_Pymt_Flg && (
						<button
							type="submit"
							className={["primary__btn", styles.btn].join(" ")}
							disabled={
								(payingWithBillNumber &&
									(!billNumber ||
										!billInfo ||
										(billInfo?.billDetails
											?.CentralisedBillDetails?.length ===
											1 &&
											(!revenue || !mda)))) ||
								(!payingWithBillNumber &&
									((ESBN && ESBN.length < 10) ||
										!noBillPaymentRef ||
										!name ||
										!address ||
										!mda ||
										!revenue ||
										!amount)) ||
								(isCoreTax && ESBN.length < 10) ||
								(amount &&
									billInfo?.billDetails
										?.CentralisedBillDetails?.length > 1 &&
									+amount < 2000) ||
								(!+amount && !billInfo?.Balance) ||
								(Boolean(amount.length) && !+amount) ||
								paying
							}
						>
							{paying
								? `Paying ₦ 
						${formatAmount(amount || billInfo?.Balance)}
						... `
								: `Pay ₦ 
						${formatAmount(amount || billInfo?.Balance)}
						 now`}
						</button>
					)}
				</form>
			</main>
		</div>
	);
};

export default RemitaCheckout;
